import React, { useState, useEffect, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { FaCalendarAlt, FaBookOpen, FaStar, FaClipboardCheck, FaAlignLeft, FaPlus, FaMinus } from 'react-icons/fa';
import Select from 'react-select';
import { getSelectStyles } from '../../components/Select/selectStyles';
import { termOptions } from '../../utils/helper';
import CustomSelect from '../../components/Select/Select';
import MultiSelect from '../../components/Select/MultiSelect';
import Input from '../../components/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrograms } from '../../redux/program/programActions';
import { fetchEvaluationTypes } from '../../redux/evaluationType/evaluationTypeActions';
import { fetchTraits } from '../../redux/trait/traitActions';
import { getClassInChargeClasses } from '../../services/ProgramServices';
import ExamHeaderSelect from '../ExamConfiguration/ExamHeaderSelect';
import './ExamConfigForm.css';

const ExamConfigForm = ({ props }) => {
  const [programList, setProgramList] = useState([]);
  const session_id = localStorage.getItem('session_id');
  const role_name = JSON.parse(localStorage.getItem("roles"))[0].name;
  const dispatch = useDispatch();
  const programData = useSelector(state => state.program.programs.data);
  const evaluationType = useSelector(state => state.evaluationType.evaluationTypes.data);
  const traitData = useSelector(state => state.trait.traits.data);
  const getProgramList = useCallback(async () => {
    try {
      const response = await getClassInChargeClasses(session_id);
      if (response.status === 200) {
        setProgramList(response.data.data);
      }
    } catch (error) {
      console.error('Error', error);
    }
  }, [session_id]);

  useEffect(() => {
    getProgramList();
    /***            Get Program   *** */
    dispatch(fetchPrograms());
    /***            Get Evalauation Type  *** */
    dispatch(fetchEvaluationTypes());
    // get trait
    dispatch(fetchTraits());
  }, [dispatch, getProgramList]);

  return (
    <React.Fragment>
      <div className="ecf-section">
        <div className="ecf-section-title">
          <FaCalendarAlt />
          <span>Exam Details</span>
        </div>
        <div className="row">
          <div className="col-md-3">
            <CustomSelect
              label="Class"
              name="program_id"
              value={props.program_id}
              placeholder={"Select Class"}
              onChangeHandler={props.changeHandler}
              options={(role_name === "SUPER ADMIN" || role_name === "SCHOOL SPOC" || role_name === "ADMIN") ? programData : programList}
              required={true}
            />
          </div>
          <div className="col-md-3">
            <ExamHeaderSelect
              label="Assessment Name"
              name="name"
              placeholder={"Select Exam Headers"}
              value={props.data.name}
              onChangeHandler={props.changeHandler}
              examList={props.data.examList}
            />
          </div>
          <div className="col-md-3">
            <Input
              label="Evaluation Period Start"
              type="date"
              name="start"
              value={props.data.start}
              onChangeHandler={props.changeHandler}
              required={true}
            />
          </div>
          <div className="col-md-3">
            <Input
              label="Evaluation Period End"
              type="date"
              name="end"
              value={props.data.end}
              onChangeHandler={props.changeHandler}
              required={true}
            />
          </div>
        </div>
      </div>

      <div className="ecf-section">
        <div className="ecf-section-title">
          <FaBookOpen />
          <span>Subject &amp; Grading</span>
        </div>
        <div className="row">
          <div className="col-md-3">
            {props.data.id ?
              <CustomSelect
                label="Subject"
                name="subject_id"
                value={props.data.subject_id}
                placeholder={"Select Subject"}
                onChangeHandler={props.changeHandler}
                options={props.subjectData}
                required={true}
              /> :
              <Form.Group>
                <Form.Label>Subject</Form.Label>
                <MultiSelect
                  options={props.subjectData} // Options to display in the dropdown
                  onSelect={props.onSubjectSelect} // Function will trigger on select event
                  selectedValues={props.selectedSubjects}
                  onRemove={props.onSubjectRemove} // Function will trigger on remove event
                  closeOnSelect={false}
                  isMulti={props.studentSubjectWise ? false : true}
                  id="program_ids"
                  placeholder="Select Subject"
                  displayValue="name" // Property name to display in the dropdown options
                />
              </Form.Group>}
          </div>
          <div className="col-md-3">
            <CustomSelect
              label="Term"
              name="term"
              value={props.data.term}
              placeholder={"Select Term"}
              onChangeHandler={props.changeHandler}
              options={termOptions}
              required={true}
            />
          </div>
          <div className="col-md-3">
            <CustomSelect
              label="Evaluation Type"
              name="evaluation_type_id"
              value={props.data.evaluation_type_id}
              placeholder={"Select Evaluation Type"}
              onChangeHandler={props.changeHandler}
              options={evaluationType}
              required={true}
            />
          </div>
          <div className="col-md-3">
            <CustomSelect
              label="Grade Schemes"
              name="gradeSchemeID"
              value={props.gradeSchemeID}
              placeholder={"Select Grade Schemes"}
              onChangeHandler={props.changeHandler}
              options={props.scoreSchemesData}
              required={true}
            />
          </div>
        </div>
        <div className="ecf-switch-row">
          <Form.Check
            type="checkbox"
            label="Is Active"
            name="is_active"
            id="is_active"
            checked={!!props.data.is_active}
            onChange={props.changeHandler}
          />
          <Form.Check
            type="checkbox"
            label="Traits"
            name="is_traits"
            id="is_traits"
            checked={!!props.data.is_traits}
            onChange={props.changeHandler}
          />
        </div>
      </div>

      {props.data.is_traits && (
        <div className="ecf-section">
          <div className="ecf-section-title">
            <FaStar />
            <span>Traits</span>
          </div>
          {props.data.traits.map((val, idx) => (
            <div className="ecf-trait-row" key={idx}>
              <Form.Group style={{ flex: '2 1 auto' }}>
                <Select
                  value={val.trait_id === undefined ? { label: 'Choose trait', value: "" } : { label: val.label, value: val.trait_id }}
                  onChange={(option) => props.changeTraitHandler({ target: { value: option.value, name: 'trait_id', label: option.label } }, idx)}
                  options={traitData && traitData.map(trait => ({ label: trait.name, value: trait.id }))}
                  placeholder="Choose Trait"
                  styles={getSelectStyles()}
                />
              </Form.Group>
              {props.data.traits[idx].trait_grade_scheme_type === 'Score' && (
                <Input
                  name={"max_score"}
                  id={"trait_max_score"}
                  placeholder={"Max Score"}
                  value={props.data.traits[idx].max_score || ''}
                  type="number"
                  onChange={(e) => props.changeTraitHandler(e, idx)}
                  required={true}
                />
              )}
              {idx === 0 ? (
                <button
                  onClick={props.addRow}
                  type="button"
                  className="ecf-trait-action-btn add"
                  title="Add trait"
                >
                  <FaPlus />
                </button>
              ) : (
                <button
                  onClick={(e) => props.clickOnDelete(e, val)}
                  type="button"
                  className="ecf-trait-action-btn remove"
                  title="Remove trait"
                >
                  <FaMinus />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {(props.data.attempts === "YES" || props.grade_scheme_type === 'Score') && (
        <div className="ecf-section">
          <div className="ecf-section-title">
            <FaClipboardCheck />
            <span>Attempts &amp; Scoring</span>
          </div>
          <div className="row">
            {props.data.attempts === "YES" && (
              <React.Fragment>
                <div className="col-md-3">
                  <Input
                    label="No of Attempts"
                    type="number"
                    name="total_attempts"
                    value={props.data.total_attempts}
                    onChangeHandler={props.changeHandler}
                    required={true}
                  />
                </div>
                <div className="col-md-3">
                  <CustomSelect
                    label="Choose Grading Method"
                    name="grade_method"
                    value={props.data.grade_method}
                    placeholder={"Select Graging Method"}
                    onChangeHandler={props.changeHandler}
                    options={props.data.gradingMethodsData}
                    required={true}
                  />
                </div>
              </React.Fragment>
            )}
            {props.grade_scheme_type === 'Score' && (
              <div className="col-md-3">
                <Input
                  label="Max Score"
                  type="number"
                  name="maxScore"
                  value={props.data.maxScore}
                  onChangeHandler={props.changeHandler}
                  required={true}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className="ecf-section">
        <div className="ecf-section-title">
          <FaAlignLeft />
          <span>Description</span>
        </div>
        <Form.Group>
          <Form.Control as="textarea" name="description" id="description"
            className="form-control daterange mb-2"
            type="text" placeholder="Enter description"
            value={props.data.description || ''}
            onChange={props.changeHandler} row={3} />
        </Form.Group>
      </div>
    </React.Fragment>
  );
};
export default ExamConfigForm;
